import MultiToggle from "PFComponents/multi_toggle";
import { getWeekdays } from "PFCore/helpers/date";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./schedule_settings_modal.module.scss";

type WeeklySelectorProps = {
  value: string | null;
  onChange: (value: string) => void;
};

export const WeeklySelector = ({ value, onChange }: WeeklySelectorProps): JSX.Element => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports.exportWizard" });
  const weekdays = getWeekdays();

  return (
    <>
      <div className={css.weeklySelector}>
        <MultiToggle<string>
          options={weekdays.map((weekday) => ({
            id: weekday,
            value: weekday[0]
          }))}
          defaultSelected={value || weekdays[0]}
          rounded
          onChange={onChange}
        />
      </div>

      <span className={css.label}>{t("weeklySelectorSummary", { weekday: value })}</span>
    </>
  );
};
